<template>
  <div>
    <v-text-field
      box
      label="Respuesta"
      :error-messages="numberErrors"
      placeholder="Ingrese su respuesta"
      v-model="answer"
      :data-question="question.id"
      @input="$emit('get_answer', { option: answer, question: question})"
      @blur="$v.answer.$touch()"
    ></v-text-field>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, integer } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      answer: ""
    };
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  validations: {
    answer: {
      required,
      integer
    }
  },
  computed: {
    numberErrors() {
      const errors = [];
      if (!this.$v.answer.$dirty) return errors;
      !this.$v.answer.integer && errors.push("Debe ingresar número.");
      if (!this.question.optional)
        !this.$v.answer.required && errors.push("Este campo es requerido.");
      return errors;
    }
  }
};
</script>

<style>
</style>